import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

import { IRIMSActions, ICheckoutProps } from '../types';

interface ICheckoutState {
  hasError: boolean;
  invalidPIN: boolean;
}

declare var showInfoDialog;

class Checkout extends React.Component<ICheckoutProps, ICheckoutState> {
  feederRef: React.RefObject<HTMLInputElement>;
  woRef: React.RefObject<HTMLInputElement>;
  noteRef: React.RefObject<HTMLTextAreaElement>;
  pinRef: React.RefObject<HTMLInputElement>;

  constructor(props) {
    super(props);
    this.feederRef = React.createRef();
    this.woRef = React.createRef();
    this.noteRef = React.createRef();
    this.pinRef = React.createRef();

    this.state = {
      hasError: false,
      invalidPIN: false
    }
  }

  itemsSum = (items = {}) => Object.values(items).reduce((sum : number, { quantity } : any) => sum + parseInt(quantity), 0);

  handleShowCheckoutModal = () => {
    const { items } = this.props;
    Object.keys(items).forEach((itemNumber) => {
      // @ts-ignore
      document.getElementById(`quantity_${itemNumber}`).value = items[itemNumber].quantity;
    });
    $('#checkout_inventory_request_modal').modal('show');
  }

  handleClearItem = () => {
    const { code, clearInventoryRequest } = this.props;
    clearInventoryRequest({ code });
  };

  handleSetItem = (itemNumber, event) => {
    const { code, items } = this.props;
    const item = items[itemNumber];
    const quantity = parseInt(event.target.value);
    if (!isNaN(quantity) && quantity > 0 && quantity <= parseInt(item.inStock)) this.props.setInventoryRequest({ code, itemNumber, ...item, quantity });
  };

  handleResetItem = (itemNumber, event) => {
    const quantity = parseInt(event.target.value);
    const { items } = this.props;
    const item = items[itemNumber];
    if (isNaN(quantity) || quantity < 1 || quantity > parseInt(item.inStock)) {
      event.target.value = item.quantity;
    }
  };

  handleUnsetItem = (itemNumber) => {
    const { code } = this.props;
    this.props.unsetInventoryRequest({ code, itemNumber });
    $('.ui-tooltip').hide();
  };

  handleCheckout = (e) => {
    if (!$('#wo_number').is(':valid') || !$('#feeder_number').is(':valid')) {
      return;
    }

    e.preventDefault();
    const { checkout_url, items } = this.props;
    const data = {
      // @ts-ignore
      authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
      items: Object.keys(items).map(itemNumber => ({ item_number: itemNumber, requested_qty: items[itemNumber].quantity }))
    }

    axios.post(checkout_url, data)
      .then(({ data }) => {
        let hasError = false;
        const { code, setInventoryRequest } = this.props;
        data.items.forEach((item) => {
          const old_item = items[item.item_number];
          if (parseInt(old_item.quantity) > item.in_stock) {
            hasError = true;
          }
          setInventoryRequest({ code, ...old_item, itemNumber: item.item_number, inStock: item.in_stock });
        });

        this.setState({ hasError });

        if (!hasError) {
          $('#checkout_inventory_request_modal').modal('hide');
          // @ts-ignore
          document.getElementById('pin_number').value = '';
          $('#pin_inventory_request_modal').modal('show');
        }
      });
  };

  checkMaxLength = (maxLength, event) => {
    event.target.value = event.target.value.substring(0, maxLength);
  };

  handlePin = (e) => {
    e.preventDefault();

    const { code, items, url } = this.props;
    const data = {
      // @ts-ignore
      authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
      pin: this.pinRef.current.value,
      requests: {
        feeder_number: this.feederRef.current.value,
        wo_number: this.woRef.current.value,
        note: this.noteRef.current.value,
        items: Object.keys(items).map(itemNumber => ({ item_number: itemNumber, requested_qty: items[itemNumber].quantity }))
      }
    };

    this.setState({ invalidPIN: false });

    axios.post(url, data)
      .then(({data}: any) => {
        this.props.clearInventoryRequest({ code });
        $('#pin_inventory_request_modal').modal('hide');
        showInfoDialog('Item(s) checked out successfully!');

        if (data.redirect_to !== null) {
          $('#info-dialog').on('hidden.bs.modal', function () {
            window.location = data.redirect_to;
          });
        }
      })
      .catch(({response}) => {
        switch(response.status) {
          case 400:
            break;

          case 404: // Invalid PIN#
            this.setState({ invalidPIN: response.data.message });
            break;
        }
      });
  };

  render () {
    const { items } = this.props;
    const { hasError, invalidPIN } = this.state;

    return (
      <>
        <button className='sn-btn sn-btn-md sn-btn-teal' type='button' onClick={this.handleShowCheckoutModal}>Checkout Request</button>
        <span className='sn-blue-circle'>{this.itemsSum(items)}</span>

        <div className='modal fade sn-unset-right-align' role='dialog' id='checkout_inventory_request_modal' tabIndex={-1}>
          <div className='modal-dialog modal-lg'>
            <div className='sn-modal modal-content'>
              <form className='sn-form' onSubmit={this.handleCheckout}>
                <div className='modal-header'>
                  <button type='button' className='close' data-dismiss='modal'>&times;</button>
                  <h3><strong>Checkout Request</strong></h3>
                </div>
                <div className='modal-body'>
                  <div className='row'>
                    <div className='form-group col-xs-12 col-sm-6'>
                      <label htmlFor='wo_number'>WO#</label>
                      <input type='number' min={1} max={9999999999} className='form-control' ref={this.woRef} id='wo_number' onChange={(...props) => this.checkMaxLength(10, ...props)}  />
                    </div>
                    <div className='form-group col-xs-12 col-sm-6'>
                      <label htmlFor='feeder_number' className='required'>Feeder#</label>
                      <input type='number' min={1} max={999999} className='form-control' ref={this.feederRef} id='feeder_number' required={true} onChange={(...props) => this.checkMaxLength(6, ...props)}  />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xs-12'>
                      <table className='sn-table table table-hover table-responsive'>
                        <thead className='green-header'>
                          <tr>
                            <th className='text-center'>#</th>
                            <th style={{ width: '50%' }}>Item Information</th>
                            <th className='text-left'></th>
                            <th className='text-center'>Quantity</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.keys(items).map((itemNumber, index) => {
                            const item = items[itemNumber];
                            return (
                              <tr key={itemNumber} className="checkout_border">
                                <td className='text-center heighter'>{index + 1}</td>
                                <td style={{ width: '50%' }}>
                                  {itemNumber}
                                  <br/>
                                  <span className='text-gray sn-small-text'>{item.description}</span>
                                </td>
                                <td className={`text-center ${parseInt(item.inStock) < parseInt(item.quantity) ? 'text-danger' : ''}`}>
                                  <br/>
                                  In-Stock: {item.inStock}
                                </td>
                                <td className='text-center'style={{ width: '15%' }}>
                                  <input type='number' min={1} max={item.inStock} className='form-control text-center' id={`quantity_${itemNumber}`}
                                    onBlur={(...props) => this.handleResetItem(itemNumber, ...props)}
                                    onChange={(...props) => this.handleSetItem(itemNumber, ...props)}
                                  />
                                </td>
                                <td className='text-center sn-icons'>
                                  <a href='#' className='fa fa-minus-circle fa-2x circle-delete-icon' title='Delete' data-toggle='tooltip' onClick={() => this.handleUnsetItem(itemNumber)} />
                                </td>
                              </tr>);
                          })}
                          <tr>
                            <td colSpan={3}> </td>
                            <td className='text-center bold'>{this.itemsSum(items)}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {hasError &&
                  <div className='row'>
                    <div className='form-group col-xs-12 text-danger'>
                      Items in stock has been updated, please change the quantities!
                    </div>
                  </div>
                  }
                  <div className='row'>
                    <div className='form-group col-xs-12'>
                     <label htmlFor='note'>Note</label>
                     <textarea name='note' id='note' rows={4} className='form-control' ref={this.noteRef} />
                    </div>
                  </div>
                </div>
                <div className='modal-footer'>
                  <button type='button' className='sn-btn sn-btn-silver sn-btn-sm' data-dismiss='modal'>Close</button>
                  &nbsp;
                  <button type='button' className='sn-btn sn-btn-red sn-btn-sm' onClick={this.handleClearItem} disabled={Object.keys(items).length ? false: true}>Clear</button>
                  &nbsp;
                  <button type='submit' className='sn-btn sn-btn-teal sn-btn-sm' onClick={this.handleCheckout} disabled={Object.keys(items).length ? false: true}>Checkout</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className='modal fade sn-unset-right-align' role='dialog' id='pin_inventory_request_modal' tabIndex={-1}>
          <div className='modal-dialog modal-md'>
            <div className='sn-modal modal-content'>
              <form className='sn-form' onSubmit={this.handlePin}>
                <div className='modal-header'>
                  <button type='button' className='close' data-dismiss='modal'>&times;</button>
                  <h3><strong>PIN# Confirmation</strong></h3>
                </div>
                <div className='modal-body'>
                  <div className='row'>
                    <div className='form-group col-xs-12'>
                      <label htmlFor='pin_number' className='required'>PIN#</label>
                      <input type='password' className='form-control' required ref={this.pinRef} id="pin_number" />
                      {invalidPIN && <span className='text-danger'>{invalidPIN}</span>}

                    </div>
                  </div>
                </div>
                <div className='modal-footer'>
                  <button type='button' className='sn-btn sn-btn-silver sn-btn-sm' data-dismiss='modal'>Close</button>
                  &nbsp;
                  <button type='submit' className='sn-btn sn-btn-teal sn-btn-sm'>Confirm</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, props) => ({
  items: state.inventoryRequests.items[props.code] || [],
});

const mapDispatchToProps = dispatch => ({
  setInventoryRequest: (payload: any) => dispatch({ type: IRIMSActions.SetInventoryRequest, payload }),
  unsetInventoryRequest: (payload: any) => dispatch({ type: IRIMSActions.UnsetInventoryRequest, payload }),
  clearInventoryRequest: (payload: any) => dispatch({ type: IRIMSActions.ClearInventoryRequest, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
